module.exports = __webpack_public_path__ + "static/media/applenav-mac.a3d69c7f.PNG";